export const AUTH_ENDPOINT = "https://vipguide.experienceinnovation.co.uk/_api/_auth/backoffice/";
export const IMAGES_ENDPOINT = "https://vipguide.experienceinnovation.co.uk/_api/_auth/images/";
export const BASE_CUSTOMER_URL = "https://vipguide.experienceinnovation.co.uk/_customers/";
export const COLOR_BRAND = "#131313";
export const CACHE_BUST_TS = Date.now();

export const withNoCache = (url) => {
  const separator = url.includes("?") ? "&" : "?";
  return `${url}${separator}_ts=${CACHE_BUST_TS}`;
};
